<template>
  <div>
    <div class="main-content">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <div class="card-title">
                {{
                  cbo.id ? $t("cbo.form.titleEdit") : $t("cbo.form.titleNew")
                }}
              </div>
            </div>
            <hr style="margin-top: -4px" />
            <div class="card-body">
              <div class="row">
                <div class="col-md-12">
                  <div class="form-row">
                    <div class="form-group col-md-6">
                      <label for="Name">
                        <span class="required">*</span>
                        {{ $t("cbo.form.nameLabel") }}
                      </label>
                      <input
                        autocomplete="new-password"
                        type="text"
                        id="Name"
                        class="form-control"
                        v-model="cbo.cbo_name"
                        placeholder=""
                      />
                    </div>

                    <div class="form-group col-md-6">
                      <label for="Name">
                        <span class="required">*</span>
                        {{ $t("cbo.form.shortNameLabel") }}
                      </label>
                      <input
                        autocomplete="new-password"
                        type="text"
                        id="Name"
                        class="form-control"
                        v-model="cbo.cbo_short_name"
                        placeholder=""
                      />
                    </div>
                  </div>

                  <div class="form-row">
                    <div class="form-group col-md-6">
                      <label for="Name">
                        <span class="required">*</span>
                        {{ $t("cbo.form.codeSusLabel") }}
                      </label>
                      <input
                        autocomplete="new-password"
                        type="text"
                        id="Name"
                        class="form-control"
                        v-model="cbo.cbo_code_sus"
                        placeholder=""
                      />
                    </div>

                    <div class="form-group col-md-6">
                      <label for="Name">
                        <span class="required">*</span>
                        {{ $t("cbo.form.statusLabel") }}
                      </label>
                      <select v-model="cbo.status" class="form-control">
                        <option :value="1">{{ $t("common.active") }}</option>
                        <option :value="0">{{ $t("common.inactive") }}</option>
                      </select>
                    </div>
                  </div>

                  <FieldSchemaEditor :value="fieldSchema" allow-prescription />

                  <span class="required_fields mt-2 d-block">
                    <span class="required">*</span>
                    <strong>{{ $t("cbo.form.requiredFields") }}</strong>
                  </span>
                  <div class="block text-right">
                    <router-link to="/cbos" class="btn btn-back mr-1">
                      <i class="fa fa-arrow-left"></i> {{ $t("common.back") }}
                    </router-link>
                    <a v-if="$hasAbility('cadastro.gerenciar')" class="btn btn-add" @click="save">
                      {{ $t("common.save") }}
                      <i class="fa fa-save"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BaseCrud from "../../layouts/Base/BaseCrud";
import vSelect from "vue-select";
import Loading from "vue-loading-overlay";
import FieldSchemaEditor from "@/components/FieldSchemaEditor.vue";

export default {
  data() {
    return {
      cbo: {
        cbo_name: "",
        cbo_short_name: "",
        cbo_code_sus: "",
        status: "1",
      },
      fieldSchema: [],
    };
  },
  computed: {},
  methods: {
    save: function () {
      const self = this;
      let api = self.$store.state.api + "cbos";

      if (self.cbo.id) {
        self.cbo._method = "PUT";
        api += "/" + self.cbo.id;
      }

      // keyEdited é só controle do editor; não vai para o esquema salvo.
      self.cbo.field_schema = self.fieldSchema.length
        ? self.fieldSchema.map(({ keyEdited, ...field }) => field)
        : null;

      self.$loading(true);

      axios
        .post(api, self.cbo)
        .then((response) => {
          self.$message(
            self.$t("cbo.messages.saveSuccessTitle"),
            self.$t("cbo.messages.saveSuccessMessage"),
            "success"
          );
          self.$loading(false);
          this.$router.push("/cbos");
        })
        .catch((error) => {
          self.$loading(false);
          self.$message(null, error.response.data, "error");
        });
    },
    getCbo: function (id) {
      const self = this;
      const api = self.$store.state.api + "cbos/" + id;
      self.$loading(true);

      axios
        .get(api)
        .then((response) => {
          self.cbo = response.data.data[0];
          self.fieldSchema = (self.cbo.field_schema || []).map((f) => ({
            options: [],
            ...f,
          }));
          self.$loading(false);
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
  },
  mounted: function () {
    const self = this;

    let id = self.$route.params.id;
    if (id) {
      self.getCbo(id);
    }
  },
  components: {
    BaseCrud,
    vSelect,
    Loading,
    FieldSchemaEditor,
  },
};
</script>
<style scoped>
.profile_user {
  text-align: center;
}
.photo {
  display: block;
  margin-left: 5px;
  width: 18%;
  border-radius: 10px;
  max-width: 400px;
  max-height: 400px;
  object-fit: cover;
}
.btn-user:hover,
.btn-user[aria-expanded="true"] {
  background: linear-gradient(to right, #000, #666);
  color: #fff !important ;
}
.photo-title {
  color: #000;
  font-size: 18px;
  display: block;
  margin-left: 5px;
  width: 18%;
}
</style>